export const chartDays = [
  {
    label: "Price",
    value: 'prices',
  },
  {
    label: "Market Capital",
    value: 'market_caps',
  },
  {
    label: "Volume",
    value: 'total_volumes',
  },
];
